'use strict';
const random = require('lodash/random');
const angular = require('angular');
const {isNumber, isString} = angular;

module.exports = function () {
  return {
    $get: [
      '$injector',
      'AvatarColors',
      'AuthService',
      'FirebaseConnectionService',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function ($injector, AvatarColors, AuthService, FirebaseConnectionService, FirebaseQueueService,
                ROOT_API_COLLECTION, ROOT_API_SPEC) {
        var FileDomain;

        function hasAvatar(Class) {

          Class.$constraints.addConstraints({
            avatar: {type: 'Domain', domainClass: 'FileDomain', nullable: true},
            avc: {type: 'number', min: 0, max: AvatarColors.length - 1, defaultValue: getRand}
          });

          /**
           * TODO: Convert to sending a command to the server
           * @param {string} id
           * @param fileDomain
           * @returns {*}
           */
          Class.$setAvatar = function $setAvatarStatic(id, fileDomain) {
            return Class.$get(id).then(function onGetInstance(instance) {
              return instance.$setAvatar(fileDomain);
            });
          };

          Class.prototype.$setAvatar = $setAvatar;
          Class.prototype.getAvatarColor = getAvatarColor;
          Class.prototype.getAvatarFontColor = getAvatarFontColor;
          Class.prototype.addAvatarColorToLegacy = addAvatarColorToLegacy;
        }

        function $setAvatar(fileDomain) {
          //console.log(Class.name + '.$setAvatar', fileDomain);
          if (!fileDomain) return Promise.reject('AvatarMixin.$setAvatar: Expected file domain object');
          lookupServices();
          var fileId;
          var instance = this;
          if (isString(fileDomain)) {
            fileId = fileDomain;
          } else if (fileDomain.fileId) {
            fileId = fileDomain.fileId;
          } else if (fileDomain.id) {
            fileId = fileDomain.id;
          } else if (fileDomain.$id) {
            fileId = fileDomain.$id;
          } else {
            return Promise.reject('AvatarMixin.$setAvatar: Expected file domain object');
          }

          return FileDomain.$get(fileId).then(function (fileDomain) {
            //console.log(Class.name + '.$setAvatar retrieved', fileDomain);
            instance.avatar = fileDomain;

            return instance.$save();
          });
        }

        function getAvatarColor() {
          var val = this.avc;
          if (isNumber(val) && val < AvatarColors.length) {
            return AvatarColors[val];
          } else {
            this.avc = getRand();
            this.addAvatarColorToLegacy();
            return AvatarColors[this.avc];
          }
        }

        function getAvatarFontColor() {
          var val = this.avc;
          if (isNumber(val) && val < AvatarColors.length) {
            return AvatarColors.getFontColor(val);
          } else {
            this.getAvatarColor();
            return AvatarColors.getFontColor(this.avc);
          }
        }

        function getRand() {
          return random(AvatarColors.length - 1);
        }

        function lookupServices() {
          if (!FileDomain) {
            FileDomain = $injector.get('FileDomain');
          }
        }

        function addAvatarColorToLegacy() {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});

          var request = {
            method: 'avatars/legacy/color',
            collection: this.$class.COLLECTION,
            id: this.$id,
            avc: this.avc
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        }

        return hasAvatar;
      }]
  }
};


// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/AvatarMixin.js